import styled from 'styled-components';
import { font } from '@chegg-ui/theme';
export var Container = styled.div.withConfig({
  componentId: "sc-1je342w-0"
})(["display:flex;font-size:0.8125rem;line-height:", ";flex-direction:column;"], font.lineHeight.md);